import { useState } from 'react'
import { Card, CardContent, Collapse, Typography, Stack, Box, IconButton } from '@mui/material'
import { ExpandMore } from '@mui/icons-material'
import { RELATIONSHIP_DEFS } from './map-inspector/use-map-crops-styles'

const LEGEND_ENTRIES = Object.values(RELATIONSHIP_DEFS).map(def => ({
  key: def.countKey,
  label: def.label,
  Icon: def.Icon,
  muiColor: def.muiColor,
}))

export const RelationshipLegend = ({ counts, orgName }) => {
  const [open, setOpen] = useState(true)

  return (
    <Card sx={{
      position: 'absolute',
      bottom: 16,
      right: 16,
      zIndex: 1000,
      minWidth: 200,
      boxShadow: 3,
      border: theme => `1px solid ${theme.palette.primary.main}`,
    }}>
      <Box
        onClick={() => setOpen(o => !o)}
        sx={{
          display: 'flex',
          alignItems: 'center',
          px: 1.5,
          py: 0.75,
          cursor: 'pointer',
          userSelect: 'none',
        }}
      >
        <Typography variant="caption" fontWeight="bold" noWrap sx={{ flex: 1 }}>
          {orgName ?? 'Legend'}
        </Typography>
        <IconButton size="small" tabIndex={-1} sx={{ ml: 0.5, p: 0.25, pointerEvents: 'none' }}>
          <ExpandMore sx={{
            fontSize: 16,
            transition: 'transform 200ms',
            transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
          }} />
        </IconButton>
      </Box>

      <Collapse in={open}>
        <CardContent sx={{ p: 1.5, pt: 0, '&:last-child': { pb: 1.5 } }}>
          <Stack spacing={0.5}>
            {LEGEND_ENTRIES.map((entry) => (
              <Box key={entry.key} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <entry.Icon sx={{ fontSize: 14, color: entry.muiColor, flexShrink: 0 }} />
                <Typography variant="caption" sx={{ flex: 1, color: 'text.secondary' }}>
                  {entry.label}
                </Typography>
                <Typography variant="caption" fontWeight="medium">
                  {counts[entry.key]}
                </Typography>
              </Box>
            ))}
          </Stack>
        </CardContent>
      </Collapse>
    </Card>
  )
}
